// src/utils/dataUtils.js
//import { data } from "autoprefixer";
import { chartOptions } from "../chartConfig";

export const parseDate = (dateString) => {
  return new Date(dateString);
};

export const getDateRange = () => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);

  return {
    startDate: new Date(startDate.setHours(0, 0, 0, 0))
      .toISOString()
      .split(".")[0],
    endDate: new Date(endDate.setSeconds(0)).toISOString().split(".")[0],
  };
};

export const prepareChartData = (dataPoints) => {
  // Find the overall min and max values across both datasets
  const allValues = dataPoints.flatMap((point) => [point.Aver30, point.Limit]);
  const min = Math.min(...allValues);
  const max = Math.max(...allValues);

  // Add some padding to the min/max for better visualization
  const padding = (max - min) * 0.1;

  // Update the options object with the calculated min/max
  chartOptions.scales.y.min = min - padding;
  chartOptions.scales.y.max = max + padding;
  chartOptions.scales.y1.min = min - padding;
  chartOptions.scales.y1.max = max + padding;

  return {
    datasets: [
      {
        // Label will be localized in the rendering component
        label: "Average (30min)",
        data: dataPoints.map((point) => ({
          x: point.Date,
          y: Number(point.Aver30),
        })),
        borderColor: "rgb(81, 211, 234)",
        backgroundColor: "rgba(41, 141, 216, 0.2)",
        borderWidth: 1,
        yAxisID: "y",
      },
      {
        // Label will be localized in the rendering component
        label: "Water consumption threshold",
        data: dataPoints.map((point) => ({
          x: point.Date,
          y: Number(point.Limit),
        })),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderWidth: 1,
        yAxisID: "y1",
      },
    ],
  };
};
export const prepareBarChartData = (data) => {
  return {
    labels: data.map((point) => point.Date),
    datasets: [
      {
        // Label will be localized where used
        label: "Reading",
        data: data.map((point) => ({
          x: point.Date,
          y: Number(point.Reading),
        })),
        borderColor: "rgb(81, 211, 234)",
        backgroundColor: "rgba(41, 141, 216, 0.2)",
        borderWidth: 1,
        yAxisID: "y",
      },
    ],
  };
};

// Make sure both chartOptions and prepareChartData are being exported
